import {useSearchParams} from '@github-ui/use-navigate'
import type React from 'react'
import {useEffect, useState} from 'react'
import {ModelLayout, type ModelLayoutTab} from '../../../components/models/ModelLayout'
import {Evaluation} from '../Evaluation'
import {Playground} from '../Playground'
import {Readme} from '../Readme'
import {License} from '../License'
import {Transparency} from '../Transparency'

export function ShowModel() {
  const [searchParams] = useSearchParams()
  const selectedTabFromUrl = (searchParams.get('tab') || 'readme') as ModelLayoutTab
  const [selectedTab, setSelectedTab] = useState<ModelLayoutTab>(selectedTabFromUrl)

  const selectTab = (
    tab: ModelLayoutTab,
    e: React.KeyboardEvent<HTMLAnchorElement> | React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    const url = new URL('', window.location.href)
    url.searchParams.set('tab', tab)
    history.pushState(null, '', url)
    setSelectedTab(tab)
    e.preventDefault()
  }

  // When using browser back/forward, set state from popstate
  useEffect(() => {
    function handlePopState() {
      setSelectedTab((searchParams.get('tab') || 'readme') as ModelLayoutTab)
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [searchParams])

  const renderTab = (tab: ModelLayoutTab): JSX.Element => {
    switch (tab) {
      case 'readme':
        return <Readme />
      case 'evaluation':
        return <Evaluation />
      case 'license':
        return <License />
      case 'transparency':
        return <Transparency />
      case 'playground':
        return <Playground />
    }
  }

  return (
    <ModelLayout activeTab={selectedTab} selectTab={selectTab}>
      {renderTab(selectedTab)}
    </ModelLayout>
  )
}

try{ ShowModel.displayName ||= 'ShowModel' } catch {}